<dx-popup
  [visible]="visible"
  [showTitle]="true"
  title="Price Watcher"
  [width]="900"
  [maxHeight]="'90vh'"
  height="auto"
  [showCloseButton]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  (onHiding)="onHiding()"
>
  <div *dxTemplate="let data of 'content'" class="pw-content">
    <div class="pw-search-row">
      <dx-text-box
        class="pw-query"
        [(value)]="query"
        placeholder="Product to price-check, e.g. Great Northern Super Crisp 24 pack"
        (onEnterKey)="onSearch()"
        [disabled]="loading"
      ></dx-text-box>
      <dx-button
        text="Check Prices"
        type="default"
        icon="search"
        [disabled]="loading || !query.trim()"
        (onClick)="onSearch()"
      ></dx-button>
    </div>

    @if (loading && !result) {
      <div class="pw-loading">
        <dx-load-indicator [visible]="true" height="40" width="40"></dx-load-indicator>
        <div class="pw-loading-message">{{ loadingMessage }}</div>
        <div class="pw-loading-hint">Checking live BWS prices first, then researching the other retailers — feel free to keep working, the popup will update.</div>
      </div>
    }

    @if (errorMessage && !loading) {
      <div class="pw-error">
        <i class="dx-icon-warning"></i>
        <span>{{ errorMessage }}</span>
        <dx-button text="Try again" stylingMode="outlined" (onClick)="onRefresh()"></dx-button>
      </div>
    }

    @if (result) {
      <div class="pw-result">
        <div class="pw-result-header">
          <div>
            <div class="pw-product-name">{{ result.productName }}</div>
            @if (result.category) {
              <span class="pw-category">{{ result.category }}</span>
            }
          </div>
          @if (!loading) {
            <div class="pw-checked">
              Checked {{ checkedAgo }}
              <dx-button text="Refresh" icon="refresh" stylingMode="text" (onClick)="onRefresh()"></dx-button>
            </div>
          }
        </div>

        @if (isPartial) {
          <div class="pw-partial-strip">
            <dx-load-indicator [visible]="true" height="20" width="20"></dx-load-indicator>
            <span>Live BWS prices are in — checking Dan Murphy's, Liquorland, Amazon, Woolworths &amp; Coles and working out the deal verdict…</span>
          </div>
        }

        @if (!result.partial && result.verdict && result.verdict !== 'no_retail') {
          <div class="pw-verdict-card">
            <div class="pw-best">
              <div class="pw-best-label">Best price</div>
              <div class="pw-best-price">{{ result.bestPrice | currency: result.currency }}</div>
              <span class="pw-verdict-pill" [ngClass]="'pw-verdict-' + result.verdict">{{ verdictLabel }}</span>
            </div>
            <div class="pw-score">
              <div class="pw-score-value">{{ result.dealScore }}</div>
              <div class="pw-score-label">Deal score</div>
            </div>
            <div class="pw-stats">
              <div class="pw-stat">
                <div class="pw-stat-label">Lowest known</div>
                <div class="pw-stat-value">
                  {{ result.lowPrice | currency: result.currency }}
                  @if (result.lowPriceOnPromotion) {
                    <span class="pw-promo-tag">On promo now</span>
                  }
                </div>
                @if (result.lowPriceRetailer) {
                  <div class="pw-stat-sub">{{ result.lowPriceRetailer }}</div>
                }
              </div>
              <div class="pw-stat">
                <div class="pw-stat-label">Typical</div>
                <div class="pw-stat-value">{{ result.typicalPrice | currency: result.currency }}</div>
              </div>
              <div class="pw-stat">
                <div class="pw-stat-label">High / RRP</div>
                <div class="pw-stat-value">{{ result.highPrice | currency: result.currency }}</div>
              </div>
            </div>
          </div>
        }

        @if (!result.partial) {
          <div class="pw-summary">{{ result.summary }}</div>
        }

        @if (retailOffers.length > 0) {
          <div class="pw-offers">
            <div class="pw-section-title">Current offers</div>
            @for (offer of retailOffers; track offer.retailer + offer.price) {
              <div class="pw-offer-row">
                <span class="pw-offer-retailer">{{ offer.retailer }}</span>
                @if (offer.note) {
                  <span class="pw-offer-note">{{ offer.note }}</span>
                }
                <span class="pw-offer-badge" [ngClass]="offer.verified ? 'pw-verified' : 'pw-unverified'" [title]="verificationTooltip(offer)">
                  {{ offer.verified ? '✓ Verified' : 'Unverified' }}
                </span>
                <span class="pw-offer-price">{{ offer.price | currency: result.currency }}</span>
                @if (offer.url) {
                  <a class="pw-offer-link" [href]="offer.url" target="_blank" rel="noopener">View</a>
                }
              </div>
            }
          </div>
        }

        @if (venueOffers.length > 0) {
          <div class="pw-offers pw-venue-offers">
            <div class="pw-section-title">Seen at venues / on menus <span class="pw-section-hint">(hospitality prices — not used for the verdict)</span></div>
            @for (offer of venueOffers; track offer.retailer + offer.price) {
              <div class="pw-offer-row">
                <span class="pw-offer-retailer">{{ offer.retailer }}</span>
                @if (offer.note) {
                  <span class="pw-offer-note">{{ offer.note }}</span>
                }
                <span class="pw-offer-price">{{ offer.price | currency: result.currency }}</span>
                @if (offer.url) {
                  <a class="pw-offer-link" [href]="offer.url" target="_blank" rel="noopener">View</a>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (!result && !loading && !errorMessage) {
      <div class="pw-empty">
        <i class="dx-icon-search pw-empty-icon"></i>
        <div>Enter a product name to research current retail prices across the web.</div>
        <div class="pw-empty-hint">Include the pack size for best results (e.g. "24 pack", "700ml").</div>
      </div>
    }
  </div>
</dx-popup>
